import { useStore, type TabId } from '../store';
import { activeTutorialTab, scriptForMode, useTutorialState } from '../tutorial';
import { currentMode } from './TipCard';
import { TabHerd, TabMap, TabOffice, TabPark, TabReserve } from './tabIcons';

const TABS: Array<{ id: TabId; label: string; Icon: (p: Record<string, unknown>) => preact.JSX.Element }> = [
  { id: 'reserve', label: 'RESERVE', Icon: TabReserve },
  { id: 'map', label: 'MAP', Icon: TabMap },
  { id: 'herd', label: 'HERD', Icon: TabHerd },
  { id: 'park', label: 'PARK', Icon: TabPark },
  { id: 'office', label: 'OFFICE', Icon: TabOffice },
];

export function TabBar() {
  const { tab, setTab, sim } = useStore();
  const tutorialState = useTutorialState();
  const tipTab = activeTutorialTab(scriptForMode(currentMode()), tutorialState, sim);
  return (
    <nav class="tabbar" aria-label="Main tabs">
      {TABS.map(({ id, label, Icon }) => (
        <button
          key={id}
          class={`tab${tab === id ? ' active' : ''}${tipTab === id && tab !== id ? ' tip-target' : ''}`}
          aria-current={tab === id ? 'page' : undefined}
          onClick={() => { setTab(id); }}
        >
          <span class="tab-well"><Icon /></span>
          {label}
        </button>
      ))}
    </nav>
  );
}
